import { render, staticRenderFns } from "./MonthlyComparisonCard.vue?vue&type=template&id=b15ea9b0&scoped=true"
import script from "./MonthlyComparisonCard.vue?vue&type=script&lang=js"
export * from "./MonthlyComparisonCard.vue?vue&type=script&lang=js"
import style0 from "./MonthlyComparisonCard.vue?vue&type=style&index=0&id=b15ea9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15ea9b0",
  null
  
)

export default component.exports